import { HttpResponse } from '@angular/common/http';
import { AfterContentChecked, Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { EventEmitter } from 'protractor';
import { HorariosService } from 'src/app/services/horarios.service';
import { PagamentosService } from 'src/app/services/pagamentos.service'
import { ParametrosService } from 'src/app/services/parametros.service'
import { SocketService } from 'src/app/services/socket.service';
import { StatusAgendamentoService } from 'src/app/services/status-agendamento.service';

@Component({
  selector: 'app-pix-payment',
  templateUrl: './pix-payment.component.html',
  styleUrls: ['./pix-payment.component.scss']
})
export class PixPaymentComponent implements AfterContentChecked, OnInit, OnDestroy {
  constructor(
    private parametersService: ParametrosService,
    private paymentService: PagamentosService,
    private socket: SocketService,
    public schedulingStatus: StatusAgendamentoService,
    private scheduleTImesService: HorariosService
  ) {}
  
  @Input() stepper: any

  asaasToken: string
  baseUrl: string

  chargeParams: any = {}
  chargeInfo: any
  qrCodeInfo: any

  timeLimit = 600
  timePercentage: number = 100
  timeLeft: string 
  hasPixOption: boolean = false

  paid: boolean = false
  scheduleSel = JSON.parse(sessionStorage.getItem('horarioSel'))
  userData = JSON.parse(sessionStorage.getItem('userData'));
  copiedCode: boolean = false

  ngAfterContentChecked() {
    this.getAsaasInfo()
    this.checkIfPaymentRunning()
  }

  ngOnInit(): void {
    window.onbeforeunload = () => this.ngOnDestroy()
    this.getCurrentPayment()
    this.checkIfHasPixWebhook()
  }
  
  checkIfHasPixWebhook() {
    this.paymentService.getPixWebhook().subscribe({
      next: () => {
        this.hasPixOption = true
      }, error: (err) => {
        this.hasPixOption = false
      }
    })
  }

  ngOnDestroy () {
    if(this.qrCodeInfo) {
      this.userData = JSON.parse(sessionStorage.getItem('userData'))
      if(this.userData && !this.schedulingStatus.paidWithPix) {
        this.setCurrentPayment(true)
      } else {
        this.checkIfPaymentRunning()
      }
    }
  }

  checkIfPaymentRunning () {
    const paymentInfo = sessionStorage.getItem('pixPayment')
    this.userData = JSON.parse(sessionStorage.getItem('userData'))
    if((!paymentInfo && this.chargeInfo && this.qrCodeInfo) || (!this.userData && paymentInfo)) {
      const jsonParsed = JSON.parse(paymentInfo)
      this.paymentService.deleteCharge(this.chargeInfo.id || jsonParsed.charge_id).subscribe(() => {})
      sessionStorage.removeItem('pixPayment')
      this.qrCodeInfo = undefined
      this.chargeInfo = undefined
      this.timeLimit = 600
      this.timePercentage = 100
      this.timeLeft = undefined
      clearInterval(this.interval)
    }
  }

  setCurrentPayment (reloaded?: boolean) {
    sessionStorage.setItem('pixPayment', JSON.stringify({
      time_left: this.timeLeft,
      destroyed_at: new Date().toISOString(),
      step_index: this.stepper._selectedIndex,
      charge_id: this.chargeInfo.id,
      qr_code_info: this.qrCodeInfo || null,
      reloaded: reloaded || false
    }))
  }

  getCurrentPayment () {
    let paymentInfo:any = sessionStorage.getItem('pixPayment')
    if(!paymentInfo) return

    paymentInfo = JSON.parse(paymentInfo) 
    if(!this.chargeInfo) {
      this.chargeInfo = {
        id: paymentInfo.charge_id
      }
    }

    this.qrCodeInfo = paymentInfo.qr_code_info
    const initialCounter = Math.floor(this.paymentService.getStoredLeftTime(paymentInfo.time_left, paymentInfo.destroyed_at))
    this.getPaymentInterval(initialCounter)

    this.stepper._steps._results.forEach((res, i) => {
      if(i >= paymentInfo.step_index) return
      res._customCompleted = true
    })

    this.listenToPayment(paymentInfo.charge_id)
  }

  listenToPayment(chargeId: string) {
    this.socket.listen('receive-pix' + chargeId).subscribe(resp => {
      this.pixPaid()
    })
  }

  getAsaasInfo () {
    const token = this.parametersService.getParams('ASAAS_ACCESS_TOKEN') || {
      valor: '84ae019df5ffe7bea496870365e8b1b640cba9274095d740c2b613ce60a2b38a'
    }
    const baseUrl: any = this.parametersService.getParams('ASAAS_BASE_URL') || { valor: 'https://sandbox.asaas.com/api/v3' }
    if(!token || !baseUrl) return

    this.asaasToken = token.valor
    this.baseUrl = baseUrl.valor

    this.scheduleSel = JSON.parse(sessionStorage.getItem('horarioSel'))
    this.userData = JSON.parse(sessionStorage.getItem('userData'));

    if(!this.userData || !this.scheduleSel) return

    let compradorNome = this.userData.nome
    let compradorCpfCnpj = this.userData.cpf
    if(this.userData.responsaveis) {
      const responsaveisArray = JSON.parse(this.userData.responsaveis)
      if(responsaveisArray.length > 0) {
        compradorNome = responsaveisArray[0].nome
        compradorCpfCnpj = responsaveisArray[0].cpf
      }
    }

    this.chargeParams = {
      id: this.userData.id,
      tipoPagamento: 'PIX',
      nome: this.userData.nome,
      cpfCnpj: this.userData.cpf,
      valor: Number(parseFloat(this.scheduleSel.valor).toFixed(2)),
      descricao: `${this.scheduleSel.agenda}, ${this.scheduleSel.data.replace('-', '/').replace('-', '/')} ${this.scheduleSel.hora.hora}
    - ${this.scheduleSel.procedimentoNome} - Tel: ${this.userData.fone} - E-mail: ${this.userData.email}`,
      comprador: {
        nome: compradorNome,
        cpfCnpj: compradorCpfCnpj,
        email: this.userData.email,
        endereco: this.userData.logradouro,
        cep: this.userData.cep,
        enderecoNumero: this.userData.numero,
        telefone: this.userData.fone
      }
    }
  }

  getSessionData() {
    const userData = sessionStorage.getItem('userData');
    const selecaoObj = sessionStorage.getItem('selecaoObj');
    const horarioSel = sessionStorage.getItem('horarioSel');

    const paymentInfo = {
      id: this.chargeInfo.id,
      value: Number(parseFloat(this.scheduleSel.valor).toFixed(2)),
      paidWidthPix: true
    }
    sessionStorage.setItem('infoPagamento', JSON.stringify(paymentInfo))
    const paymentSel = sessionStorage.getItem('infoPagamento')

    return {
      userData: JSON.parse(userData),
      selecaoObj: JSON.parse(selecaoObj),
      horarioSel: JSON.parse(horarioSel),
      infoPagamento: JSON.parse(paymentSel)
    };
  }

  generateCharge () {
    this.paymentService.gerarCobranca(this.chargeParams, this.asaasToken).subscribe((resp: HttpResponse<any>) => {
      this.chargeInfo = resp.body

      this.listenToPayment(this.chargeInfo.id)

      this.paymentService.getPix(this.chargeInfo.id, this.asaasToken).subscribe((resp: HttpResponse<any>) => {
        this.qrCodeInfo = resp.body
        this.setCurrentPayment()
        this.getPaymentInterval()
      })

      const data = this.getSessionData()

      const treatedData = {
        ...this.scheduleTImesService.confirmaAgendamento(data, true)
      }

      this.paymentService.storePayment(this.chargeInfo.id, treatedData).subscribe(resp => {
      })
    })
  }

  interval: any
  getPaymentInterval(initialCounter?: number) {
    let counter = initialCounter || this.timeLimit
    this.interval = setInterval(() => {
      counter--
      this.secondsToMinutes(counter)
      this.getTimePercentage(counter)
      if(!counter) {
        clearInterval(this.interval)
        this.qrCodeInfo = undefined
        this.copiedCode = false    
        this.endTimePeriod()
      }
    }, 1000)
  }

  pixPaid () {
    this.qrCodeInfo = undefined
    this.copiedCode = false
    this.schedulingStatus.paidWithPix = true
    this.schedulingStatus.infoPagamento = {
      ...this.schedulingStatus.infoPagamento,
      id: this.chargeInfo.id,
      pagamento_valor: Number(parseFloat(this.scheduleSel.valor).toFixed(2))
    }
    this.stepper.next()
  }

  endTimePeriod () {
    this.qrCodeInfo = undefined
    this.copiedCode = false
    if(this.chargeInfo && this.chargeInfo.id) {
      this.paymentService.deleteCharge(this.chargeInfo.id, true).subscribe(resp => {
        const pixPaymentInfo = sessionStorage.getItem('pixPayment')
        if(!pixPaymentInfo) return
        sessionStorage.removeItem('pixPayment')
        this.chargeInfo = undefined
        if (!JSON.parse(pixPaymentInfo).reloaded) {
          this.stepper._steps._results.forEach((res, i) => {
            if(res.label === 'stepHorario') this.stepper.selectedIndex = i
          })
        }
      })
    }
  }

  secondsToMinutes (counter) {
    const minutes = Math.floor(counter / 60)
    const seconds = counter % 60
    this.timeLeft = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  getTimePercentage (currentCounter: number) {
    this.timePercentage = (currentCounter / this.timeLimit) * 100
  }

  copyToClipBoard () {
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    selBox.value = this.qrCodeInfo.payload
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand('copy')
    document.body.removeChild(selBox)
  }
}
